export const TESTCOMPONENT_CONTAINER = 'TabsWithCollageComponent-container';
export const TESTCOMPONENT_HEADING = 'TabsWithCollageComponent-TextHeading';
